import React from 'react';
import AppModal from '../../../components/AppModal/AppModal';

// Corrections spec 6.8 — drag semantics:
//   one Suggestion            → offer Move or Copy
//   one non-Suggestion        → Copy directly (no prompt; handled by caller)
//   selection of Suggestions  → offer Move or Copy
//   mixed-status selection    → Copy all only (no prompt; handled by caller)
//
// Every story added to a destination enters as a Suggestion regardless of its
// source status — stated explicitly here because the result is easy to misread.
export default function DragIntentModal({ intent, onChoose, onClose }) {
  if (!intent) return null;
  const { count, destinationName } = intent;
  const label = count === 1 ? 'this story' : `these ${count} stories`;

  return (
    <AppModal
      isOpen
      title="Move or copy?"
      onCancel={onClose}
      maxWidth={460}
      footer={(
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, marginTop: 20 }}>
          <button className="pbnew-btn" onClick={onClose}>Cancel</button>
          <div style={{ display: 'flex', gap: 10 }}>
            {/* §1.5 — Copy is the primary action and the default focus target.
                Enter picks Copy; an explicit Move click is still available for
                the case where the user genuinely wants to shed the source. */}
            <button className="pbnew-btn" onClick={() => onChoose('move')}>Move</button>
            <button className="pbnew-btn primary" autoFocus onClick={() => onChoose('copy')}>
              Copy
            </button>
          </div>
        </div>
      )}
    >
      <div className="pbnew-scope">
        <p style={{ margin: 0, fontSize: 14, color: '#3C4A5E', lineHeight: 1.5 }}>
          Send {label} to <strong>{destinationName}</strong>.
        </p>
        <p style={{ margin: '10px 0 0', fontSize: 13, color: '#3C4A5E', lineHeight: 1.5 }}>
          <strong>Copy</strong> leaves the story here and adds it to the
          destination as a <strong>Suggestion</strong>. <strong>Move</strong>{' '}
          takes it out of this bucket instead — available only for a source
          Suggestion.
        </p>
      </div>
    </AppModal>
  );
}
